/**
 * @generated SignedSource<<ee9d9ef15e0d653d748a2c6a75e65ea5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PLUProductEditScreenDeleteMutation$variables = {
  categoryId: string;
  id: string;
};
export type PLUProductEditScreenDeleteMutation$data = {
  readonly pluCategory: {
    readonly deleteProduct: {
      readonly category: {
        readonly products: ReadonlyArray<{
          readonly id: string;
        }>;
      };
      readonly id: string;
    } | null;
  } | null;
};
export type PLUProductEditScreenDeleteMutation = {
  response: PLUProductEditScreenDeleteMutation$data;
  variables: PLUProductEditScreenDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "categoryId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PLUProduct",
  "kind": "LinkedField",
  "name": "products",
  "plural": true,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUProductEditScreenDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PLUCategoryMutation",
        "kind": "LinkedField",
        "name": "pluCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "PLUProduct",
            "kind": "LinkedField",
            "name": "deleteProduct",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PLUProductEditScreenDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PLUCategoryMutation",
        "kind": "LinkedField",
        "name": "pluCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "PLUProduct",
            "kind": "LinkedField",
            "name": "deleteProduct",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0cd16aff7005a5df56bee870949b7e11",
    "id": null,
    "metadata": {},
    "name": "PLUProductEditScreenDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PLUProductEditScreenDeleteMutation(\n  $categoryId: ID!\n  $id: ID!\n) {\n  pluCategory(id: $categoryId) {\n    deleteProduct(id: $id) {\n      id\n      category {\n        products {\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a3ff9952c6236873cd4a8eaab0b2e0d";

export default node;
